interface PageHeaderProps {
  title: string;
  subtitle?: string | undefined;
}

const PageHeader = ({ title, subtitle }: PageHeaderProps) => (
  <header className="bg-white shadow">
    <div className="mx-auto w-full px-4 py-6 sm:px-6 lg:px-8 xl:px-12">
      <h1 className="text-3xl font-bold text-[#1a202c]">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-gray-500">{subtitle}</p>}
    </div>
  </header>
);

export default PageHeader;
